import Chart from 'react-apexcharts';
import { Card, CardHeader, CardTitle, CardBody } from 'reactstrap';

const areaColors = {
  series3: '#a4f8cd',
  series2: '#60f2ca',
  series1: '#2bdac7'
};

const ApexAreaCharts = ({ direction, data }) => {
  const options = {
    chart: {
      parentHeightOffset: 0,
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: false,
      curve: 'straight'
    },
    legend: {
      position: 'top',
      horizontalAlign: 'start'
    },
    grid: {
      xaxis: {
        lines: {
          show: true
        }
      }
    },
    colors: [areaColors.series3, areaColors.series2, areaColors.series1],
    xaxis: {
      categories: data.labels
    },
    fill: {
      opacity: 1,
      type: 'solid'
    },
    tooltip: {
      shared: false
    },
    yaxis: {
      opposite: direction === 'rtl'
    }
  };

  return (
    <Card>
      <CardHeader className="d-flex flex-md-row flex-column justify-content-md-between justify-content-start align-items-md-center align-items-start">
        <CardTitle className="mb-75" tag="h4">
          Sesiones por usuario
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Chart
          options={options}
          series={data.datasets}
          type="area"
          height={400}
        />
      </CardBody>
    </Card>
  );
};
export default ApexAreaCharts;
